import { APITransport } from '@client/transports/api';

export const ReportsService = {
  getAuditHistory({ days }) {
    return APITransport.get({
      path: '/rest/domain/report/auditdata',
      query: {
        days
      }
    });
  },
  getDomainReport({ domainname, days = 30 }) {
    return APITransport.get({
      path: '/rest/user/report/domaininfo',
      query: {
        domainname,
        days
      }
    });
  },
  getRecipientReport({ email }) {
    return APITransport.post({
      path: '/rest/recip',
      body: {
        email
      }
    });
  },
  getCSReport({ domainname, days = 30 }) {
    return APITransport.get({
      path: '/rest/user/report/csreport',
      query: {
        domainname,
        days
      }
    });
  },
  getSPFReport({ domainname }) {
    return APITransport.get({
      path: '/rest/domain/report/spfinfo',
      query: {
        domainname
      }
    });
  }
};
